import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditReportName = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.8435 5.35445L15.0959 3.10364L19.0348 7.04335L16.7832 9.29417M12.8435 5.35445L5.19804 13.0007C5.04877 13.1499 4.96489 13.3523 4.96484 13.5634V17.1736H8.57506C8.78613 17.1736 8.98853 17.0897 9.13776 16.9404L16.7832 9.29417M12.8435 5.35445L16.7832 9.29417",
		stroke: "#EF4444",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 4,
		y1: 20.4236,
		x2: 20,
		y2: 20.4236,
		stroke: "#EF4444",
		strokeWidth: 1.5
	})]
});
export default SvgEditReportName;
